module.exports = __webpack_public_path__ + "img/9_1.f0f40af2.png";